<template lang="pug">
	.merchant-form
		p.sf-text Ha támogatási kérelmét szeretné eljuttatni hozzánk, kérjük, töltse ki az alábbi űrlapot. Kérjük, a jelentkezés előtt tájékozódjon a #[a(@click="$openModal($event, conditionsModalId)", href="#") jelentkezés feltételeiről]!
		form#merchant-application-form(@submit.prevent="send")
			fieldset
				legend.sf-heading-2 Szervezet adatai
				.form-row
					.form-col
						label#merchant-organization-name-label(for="merchant-organization-name-input") Szervezet neve
							VueTooltip(placement="bottom")
								p(slot="content") A programba kerülés alapfeltétele a közhasznú besorolás.
					.form-col
						VueInput(v-model="model.merchantBaseInfo.merchantName", id="merchant-organization-name-input", :max-width="352", :max-length="50", :has-error="hasError('model.merchantBaseInfo.merchantName')", @blur="$v.model.merchantBaseInfo.merchantName.$touch()", aria-describedby="merchant-organization-name-error", :aria-invalid="hasError('model.merchantBaseInfo.merchantName')")
						VueErrorMessage(id="merchant-organization-name-error", v-if="hasError('model.merchantBaseInfo.merchantName', 'required')", position="bottom") Kérjük, adja meg a szervezet nevét!
				.form-row
					.form-col
						label#merchant-organization-type-label(for="merchant-organization-type-input") Szervezet besorolása
					.form-col
						VueRadioGroup(v-model="orgType", id="merchant-organization-type-input", :options="[{ key: 'Közhasznú', value: 'Közhasznú' }, { key: 'Nem közhasznú', value: 'Nem közhasznú' }, { key: 'OTHER', value: 'Egyéb' }]", legend="Szervezet besorolása", :isLegendHidden="true", :mobileInline="false")
				.dropdown-field.dropdown-field--arrow(v-if="orgType=='OTHER'")
					svg.dropdown-arrow(width="32", height="16", viewbox="0 0 32 16", fill="none", xmlns="http://www.w3.org/2000/svg", aria-hidden="true")
						path(fill-rule="evenodd", clip-rule="evenodd", d="M13.6286 1.96444C13.8848 0.850958 14.8574 0 16 0C17.1426 0 18.1152 0.85096 18.3714 1.96444C19.3548 6.23822 22.6268 16 32 16H0C9.37315 16 12.6452 6.23822 13.6286 1.96444Z", fill="#EFF2F9")
					.dropdown-field-container
						.form-row
							.form-col
								label(for="merchant-organization-other-type-input") Egyéb besorolás
							.form-col
								VueInput(v-model="orgTypeOther", id="merchant-organization-other-type-input", :max-width="352", :max-length="50", :has-error="hasError('orgTypeOther')", @blur="$v.orgTypeOther.$touch()", aria-describedby="merchant-organization-other-type-input-error", :aria-invalid="hasError('orgTypeOther')")
								VueErrorMessage(id="merchant-organization-other-type-input-error", v-if="hasError('orgTypeOther') && hasError('orgTypeOther', 'required')", position="bottom") Kérjük, adja meg a szervezet besorolását!
				.form-row
					.form-col
						label#merchant-organization-website-label(for="merchant-organization-website-input") Szervezet honlapja vagy social media oldala
					.form-col
						VueInput(v-model="model.merchantBaseInfo.website", id="merchant-organization-website-input", :max-width="352", :max-length="50", :has-error="hasError('model.merchantBaseInfo.website')", @blur="$v.model.merchantBaseInfo.website.$touch()", aria-describedby="merchant-organization-website-error", :aria-invalid="hasError('model.merchantBaseInfo.website')")
						VueErrorMessage(id="merchant-organization-website-error", v-if="hasError('model.merchantBaseInfo.website', 'required')", position="bottom") Kérjük, adja meg a szervezet honlapját vagy social oldalát!
				.form-row
					.form-col
						label#merchant-organization-tax-number-label(for="merchant-organization-tax-number-input") Szervezet adószáma
					.form-col
						VueMaskedInput(v-model="model.merchantBaseInfo.taxNumber", id="merchant-organization-tax-number-input", :max-width="176", :max-length="13", :mask="'########-#-##'", :has-error="hasError('model.merchantBaseInfo.taxNumber')", @blur="$v.model.merchantBaseInfo.taxNumber.$touch()", aria-describedby="merchant-organization-tax-number-input-error", :aria-invalid="hasError('model.merchantBaseInfo.taxNumber')")
						VueErrorMessage(id="merchant-organization-tax-number-input-error", v-if="hasError('model.merchantBaseInfo.taxNumber', 'required')", position="bottom") Kérjük, adja meg a szervezet adószámát!
						VueErrorMessage(id="merchant-organization-tax-number-input-error", v-if="hasError('model.merchantBaseInfo.taxNumber', 'pattern')", position="bottom") Kérjük, ellenőrizze az adószámot!

			fieldset
				legend.sf-heading-2 Elérhetőségek
				.form-row
					.form-col
						label#merchant-contact-zip-code-label(for="merchant-contact-zip-code-input") Irányítószáma
					.form-col
						VueSettlementSelector(v-model="address", id="merchant-contact-zip-code-input", :settlements="settlements", :has-error="hasError('model.contact.postalCode') || hasError('model.contact.municipality')", @zip-change="getSettlements", @input="$v.model.contact.postalCode.$touch();$v.model.contact.municipality.$touch()", aria-describedby="merchant-contact-zip-code-input-error", :aria-invalid="hasError('model.contact.postalCode')")
						VueErrorMessage(id="merchant-contact-zip-code-input-error" v-if="hasError('model.contact.postalCode', 'required')", position="bottom") Kérjük, adja meg irányítószámát!
						VueErrorMessage(id="merchant-contact-zip-code-input-error" v-if="hasError('model.contact.postalCode', 'pattern')", position="bottom") Kérjük ellenőrizze az irányítószámot!
						VueErrorMessage(id="merchant-contact-zip-code-input-error" v-if="!hasError('model.contact.postalCode') && hasError('model.contact.municipality')", position="bottom") Ehhez az irányítószámhoz nem tartozik település Magyarországon. Kérjük, próbálja meg újra beírni az irányítószámot!
				.form-row
					.form-col
						label#merchant-contact-address-label(for="merchant-contact-address-input") Cím
					.form-col
						VueInput(v-model="model.contact.streetHouseNumber", id="merchant-contact-address-input", :max-width="352", :max-length="50", :has-error="hasError('model.contact.streetHouseNumber')", @blur="$v.model.contact.streetHouseNumber.$touch()", aria-describedby="merchant-contact-address-input-error", :aria-invalid="hasError('model.contact.streetHouseNumber')")
						VueErrorMessage(id="merchant-contact-address-input-error", v-if="hasError('model.contact.streetHouseNumber', 'required')", position="bottom") Kérjük, adja meg a címet!
				.form-row
					.form-col
						label#merchant-contact-name-label(for="merchant-contact-name") Kapcsolattartó neve
					.form-col
						VueInput(v-model="model.contact.representative", id="merchant-contact-name", :max-width="352", :max-length="50", :has-error="hasError('model.contact.representative')", @blur="$v.model.contact.representative.$touch()", aria-describedby="merchant-contact-name-error", :aria-invalid="hasError('model.contact.representative')")
						VueErrorMessage(id="merchant-contact-name-error", v-if="hasError('model.contact.representative', 'required')", position="bottom") Kérjük, adja meg a kapcsolattartó nevét!
				.form-row
					.form-col
						label#merchant-contact-email-label(for="merchant-contact-email") Kapcsolattartó e-mail címe
					.form-col
						VueInput(v-model="model.contact.representativeEmail", id="merchant-contact-email", :max-width="352", :max-length="50", :has-error="hasError('model.contact.representativeEmail')", @blur="$v.model.contact.representativeEmail.$touch()", aria-describedby="merchant-contact-email-error", :aria-invalid="hasError('model.contact.representativeEmail')")
						VueErrorMessage(id="merchant-contact-email-error", v-if="hasError('model.contact.representativeEmail', 'required')", position="bottom") Kérjük, adja meg a kapcsolattartó e-mail címét!
						VueErrorMessage(id="merchant-contact-email-error", v-if="hasError('model.contact.representativeEmail', 'email')", position="bottom") Kérjük, ellenőrizze az email címet!
				.form-row
					.form-col
						label#merchant-contact-mobile-phone-label(for="merchant-contact-mobile-phone") Mobiltelefonszáma
					.form-col
						VueMobilephoneInput(v-model="model.contact.representativePhoneNumber", id="merchant-contact-mobile-phone", :max-width="176", prefix="+36", addon="pl.: 20 123 4567", :has-error="hasError('model.contact.representativePhoneNumber')", @blur="$v.model.contact.representativePhoneNumber.$touch()", aria-describedby="merchant-contact-mobile-phone-error", :aria-invalid="hasError('model.contact.representativePhoneNumber')")
						VueErrorMessage(id="merchant-contact-mobile-phone-error", v-if="hasError('model.contact.representativePhoneNumber', 'required')", position="bottom") Kérjük, adja meg a kapcsolattartó mobiltelefonszámát!
						VueErrorMessage(id="merchant-contact-mobile-phone-error", v-if="hasError('model.contact.representativePhoneNumber', 'pattern')", position="bottom") Kérjük, ellenőrizze a telefonszámot!

			fieldset
				legend.sf-heading-2 Információk a projektről
				.form-row
					.form-col
						label#merchant-project-purpose-label(for="merchant-project-purpose-input") Mire gyűjtenek?
							VueTooltip(placement="bottom")
								p(slot="content") Személyes célokat nem tudunk támogatni.
					.form-col
						VueInput(v-model="model.project.projectName", id="merchant-project-purpose-input", :max-width="352", :max-length="200", :has-counter="true", :has-error="hasError('model.project.projectName')", @blur="$v.model.project.projectName.$touch()", aria-describedby="merchant-project-purpose-error", :aria-invalid="hasError('model.project.projectName')")
						VueErrorMessage(id="merchant-project-purpose-error", v-if="hasError('model.project.projectName', 'required')", position="bottom") Kérjük, adja meg, milyen gyűjtésre kéri támogatásunkat!
				.form-row
					.form-col
						label#merchant-project-description-label(for="merchant-project-description-input") Projekt rövid bemutatása
							VueTooltip(placement="bottom")
								p(slot="content") Néhány mondatban írja le a projektet!
						VueTextarea(v-model="model.project.projectDescription", id="merchant-project-description-input", :max-width="736", :max-length="1500", :min-line-number="6", :max-line-number="6", :has-counter="true", :has-error="hasError('model.project.projectDescription')", @blur="$v.model.project.projectDescription.$touch()", aria-describedby="merchant-project-description-error", :aria-invalid="hasError('model.project.projectDescription')")
						VueErrorMessage(id="merchant-project-description-error", v-if="hasError('model.project.projectDescription', 'required')", position="bottom") Kérjük, mutassa be a projektet!
				.form-row
					.form-col
						label#merchant-project-start-date-label(for="merchant-project-start-date-input") Megvalósítás kezdete
					.form-col
						datePicker(v-model="model.project.projectStart", id="merchant-project-start-date-input", :max-width="155", :default="today", :min="minStartDate", :max="maxDate", :has-error="hasError('model.project.projectStart')", @input="$v.model.project.projectStart.$touch()", aria-describedby="merchant-project-start-date-error", :aria-invalid="hasError('model.project.projectStart')")
						VueErrorMessage(id="merchant-project-start-date-error", v-if="hasError('model.project.projectStart', 'required')", position="bottom") Kérjük, adja meg a projekt megvalósításának kezdetét!
						VueErrorMessage(id="merchant-project-start-date-error", v-if="hasError('model.project.projectStart', 'date')", position="bottom") Kérjük, ellenőrizze a dátumot!
				.form-row
					.form-col
						label#merchant-project-end-date-label(for="merchant-project-end-date-input") Megvalósítás vége
					.form-col
						datePicker(v-model="model.project.projectEnd", id="merchant-project-end-date-input", :max-width="155", :default="minEndDate", :min="minEndDate", :max="maxDate", :has-error="hasError('model.project.projectEnd')", @input="$v.model.project.projectEnd.$touch()", aria-describedby="merchant-project-end-date-error", :aria-invalid="hasError('model.project.projectEnd')")
						VueErrorMessage(id="merchant-project-end-date-error", v-if="hasError('model.project.projectEnd', 'required')", position="bottom") Kérjük, adja meg a projekt megvalósításának végét!
						VueErrorMessage(id="merchant-project-end-date-error", v-if="!hasError('model.project.projectEnd', 'required') && (hasError('model.project.projectEnd', 'date') || hasError('model.project.projectEnd', 'minValue'))", position="bottom") Kérjük, ellenőrizze a dátumot!
				.form-row
					.form-col
						label#merchant-project-support-gross-amount-label(for="merchant-project-support-gross-amount-input") Támogatás bruttó összege
							VueTooltip(placement="bottom")
								p(slot="content") Max. 25m Ft támogatás kérhető!
					.form-col
						VueCurrencyInput(v-model="model.project.donationAmount", id="merchant-project-support-gross-amount-input", :max-width="176", postfix="Ft", :has-error="hasError('model.project.donationAmount')", @blur="$v.model.project.donationAmount.$touch()", aria-describedby="merchant-project-support-gross-amount-error", :aria-invalid="hasError('model.project.donationAmount')")
						VueErrorMessage(id="merchant-project-support-gross-amount-error", v-if="hasError('model.project.donationAmount', 'required')", position="bottom") Kérjük, adja meg a kért támogatás bruttó összegét!
						VueErrorMessage(id="merchant-project-support-gross-amount-error", v-if="hasError('model.project.donationAmount', 'maxValue')", position="bottom") Max. 25m Ft támogatás kérhető!
				.form-row
					.form-col
						label#merchant-project-implementing-amount-label(for="merchant-project-implementing-amount-input") Megvalósítás összköltsége
					.form-col
						VueCurrencyInput(v-model="model.project.projectCost", id="merchant-project-implementing-amount-input", :max-width="176", postfix="Ft", :has-error="hasError('model.project.projectCost')", @blur="$v.model.project.projectCost.$touch()", aria-describedby="merchant-project-implementing-amount-error", :aria-invalid="hasError('model.project.projectCost')")
						VueErrorMessage(id="merchant-project-implementing-amount-error", v-if="hasError('model.project.projectCost', 'required')", position="bottom") Kérjük, adja meg a projekt összköltségét!
						VueErrorMessage(id="merchant-project-implementing-amount-error", v-if="hasError('model.project.projectCost', 'minValue')", position="bottom") Kérjük, ellenőrizze az összköltséget, nem lehet a támogatás összegénél kevesebb!
				.form-row
					.form-col
						label#merchant-project-own-resources-label(for="merchant-project-own-resources-input") Önerő (opcionális)
					.form-col
						VueCurrencyInput(v-model="model.project.selfContribution", id="merchant-project-own-resources-input", :max-width="176", postfix="Ft", :has-error="hasError('model.project.selfContribution')", @blur="$v.model.project.selfContribution.$touch()", aria-describedby="merchant-project-own-resources-error", :aria-invalid="hasError('model.project.selfContribution')")
						VueErrorMessage(id="merchant-project-own-resources-error", v-if="hasError('model.project.selfContribution', 'maxValue')", position="bottom") Kérjük, ellenőrizze a összeget, a kért támogatás és az önerő összege meghaladja a projekt összköltségét!
				.form-row
					.form-col
						label#merchant-project-cooperate-partners-label(for="merchant-project-cooperate-partners") További együttműködő partnerek (opcionális)
					.form-col
						VueInput(v-model="model.project.partner", id="merchant-project-cooperate-partners", :max-width="352", :max-length="50")

			.form-row(v-if="captchaImg")
				.form-col
					label#merchant-captcha-label(for="merchant-captcha-input") Írja be a képen látható kódot!
				.form-col
					VueCaptcha(id="merchant-captcha-input", :img="'data:image/png;base64,' + captchaImg", v-model="model.captchaText", :max-width="104", :has-error="hasError('model.captchaText') || captchaError", @keyup="$emit('captcha-keyup')", @blur="$v.model.captchaText.$touch()", aria-describedby="merchant-captcha-error")
					VueErrorMessage(id="merchant-captcha-error" v-if="hasError('model.captchaText', 'required')", position="bottom") Kérjük, adja meg a képen látható kódot!
					VueErrorMessage(id="merchant-captcha-error" v-if="captchaError" position="bottom") Kérjük, ellenőrizze a képen látható kódot!
			hr
			.form-row
				.form-col
					VueCheckbox(id="merchant-accept-privacy-statement-input", v-model="acceptPrivacyStatement", :has-error="hasError('acceptPrivacyStatement')", @blur="$v.acceptPrivacyStatement.$touch()", aria-describedby="merchant-accept-privacy-statement-error", :aria-invalid="hasError('acceptPrivacyStatement')")
						slot Az #[a.link(:href="privacyStatementUrl", target="_blank", rel="noopener noreferrer") Adatkezelési tájékoztató] tartalmát megismertem és tudomásul vettem.
					VueErrorMessage(id="merchant-accept-privacy-statement-error", v-if="hasError('acceptPrivacyStatement', 'checked')", position="bottom") Kérjük, olvassa el és fogadja el az adatkezelési tájékoztatót!
			.form-row
				.form-col
					VueButton Elküldöm a jelentkezést
</template>
<script>
import VueButton from '@ui-common/vue-button';
import VueCaptcha from '@ui-common/vue-captcha';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueCurrencyInput from '@ui-common/vue-currency-input';
import datePicker from '../../../common/components/date-picker/date-picker.js';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueInput from '@ui-common/vue-input';
import VueMaskedInput from '@ui-common/vue-masked-input';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueSettlementSelector from '@ui-common/vue-settlement-selector';
import VueTextarea from '@ui-common/vue-textarea';
import VueTooltip from '@ui-common/vue-tooltip';
import moment from 'moment';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import pattern from '../../../common/js/validators/pattern';
import date from '../../../common/js/validators/date';
import email from '../../../common/js/validators/email';
import { TAX_NUMBER_REGEXP, ZIP_CODE_REGEXP, MOBILE_PHONE_REGEXP, BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import { jumpToFirstError } from '../../../common/js/find-first-error-component/find-first-error-component';
import { errorHandlerUtils } from '../../../common/js/error-handler-utils/error-handler-utils';

const MAX_DONATION_AMOUNT = 25000000;

export default {
	mixins: [jumpToFirstError, errorHandlerUtils],
	data: () => ({
		acceptPrivacyStatement: false,
		orgType: 'közhasznú',
		orgTypeOther: null,
		model: {
			captchaText: null,
			contact: {
				postalCode: null,
				representative: null,
				representativeEmail: null,
				representativePhoneNumber: null,
				streetHouseNumber: null,
				municipality: null
			},
			merchantBaseInfo: {
				orgType: null,
				merchantName: null,
				taxNumber: null,
				website: null
			},
			project: {
				donationAmount: null,
				partner: null,
				projectCost: null,
				projectDescription: null,
				projectEnd: null,
				projectName: '',
				projectStart: null,
				selfContribution: null
			}
		},
		address: null
	}),
	props: {
		settlements: {
			required: true
		},
		captchaImg: {
			required: true
		},
		captchaError: {
			required: true
		},
		conditionsModalId: {
			required: false,
			type: String
		},
		privacyStatementUrl: {
			required: false,
			type: String
		}
	},
	validations() {
		return {
			orgTypeOther: this.orgType == 'OTHER' ? { required } : {},
			acceptPrivacyStatement: {
				checked: value => value === true
			},
			model: {
				merchantBaseInfo: {
					merchantName: { required },
					taxNumber: { required, pattern: pattern(TAX_NUMBER_REGEXP) },
					website: { required }
				},
				captchaText: this.captchaImg
					? {
							required
					  }
					: {},
				contact: {
					postalCode: {
						required,
						pattern: pattern(ZIP_CODE_REGEXP)
					},
					municipality: {
						required
					},
					streetHouseNumber: {
						required
					},
					representative: {
						required
					},
					representativeEmail: {
						required,
						email
					},
					representativePhoneNumber: {
						required,
						pattern: pattern(MOBILE_PHONE_REGEXP)
					}
				},
				project: {
					projectName: { required },
					projectDescription: { required },
					projectStart: {
						required,
						date: date(BACKEND_DATE_FORMAT)
					},
					projectEnd: {
						required,
						date: date(BACKEND_DATE_FORMAT),
						minValue: value => moment(value).isAfter(moment(this.model.project.projectStart))
					},
					donationAmount: {
						required,
						maxValue: maxValue(MAX_DONATION_AMOUNT)
					},
					projectCost: {
						required,
						minValue: minValue(this.model.project.donationAmount)
					},
					selfContribution: {
						maxValue: maxValue(this.model.project.projectCost - this.model.project.donationAmount)
					}
				}
			}
		};
	},
	watch: {
		orgType: {
			handler(val) {
				if (val != 'OTHER') {
					this.model.merchantBaseInfo.orgType = val;
				} else {
					this.model.merchantBaseInfo.orgType = null;
				}
			},
			immediate: true
		},
		orgTypeOther(val) {
			this.model.merchantBaseInfo.orgType = val;
		},
		address(val) {
			if (val) {
				this.model.contact.postalCode = val.zipCode;
				this.model.contact.municipality = val.settlement;
			}
		},
		captchaError(val) {
			if (val) {
				this.jumpToFirstError();
			}
		}
	},
	components: {
		VueButton,
		VueCaptcha,
		VueCheckbox,
		VueCurrencyInput,
		datePicker,
		VueErrorMessage,
		VueInput,
		VueMaskedInput,
		VueMobilephoneInput,
		VueRadioGroup,
		VueSettlementSelector,
		VueTextarea,
		VueTooltip
	},
	computed: {
		today() {
			return moment().format(BACKEND_DATE_FORMAT);
		},
		minStartDate() {
			return moment()
				.subtract(5, 'years')
				.format(BACKEND_DATE_FORMAT);
		},
		minEndDate() {
			return moment()
				.add(1, 'day')
				.format(BACKEND_DATE_FORMAT);
		},
		maxDate() {
			return moment()
				.add(5, 'years')
				.format(BACKEND_DATE_FORMAT);
		}
	},
	methods: {
		getSettlements(zipCode) {
			this.$emit('zip-change', zipCode);
		},
		send() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.jumpToFirstError();
			} else {
				this.$emit('submit', this.model);
			}
		},
		resetCaptcha() {
			this.model.captchaText = null;
			this.$v.model.captchaText.$reset();
		}
	}
};
</script>
<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.merchant-form .sf-heading-2 {
	padding-left: 0;
	padding-right: 0;

	@include media('>=tablet') {
		padding-left: 60px;
		padding-right: 60px;
	}

	@include media('>=desktop') {
		padding-left: 84px;
		padding-right: 84px;
	}

	@include media('>=desktop-lg') {
		padding-left: 96px;
		padding-right: 96px;
	}
}

.merchant-form > form > fieldset {
	margin-bottom: 32px;
}

.merchant-form fieldset:first-child .sf-heading-2 {
	padding-top: 40px;
}
.merchant-form fieldset:not(:first-child) .sf-heading-2 {
	padding-top: 16px;
}

.merchant-form .dropdown-field--arrow svg.dropdown-arrow {
	left: 20px;

	@include media('>=tablet', '<desktop') {
		left: 542px;
	}

	@include media('>=desktop') {
		left: 368px;
	}

	@include media('>=desktop-lg') {
		left: 686px;
	}
}

.merchant-form .form-row .form-col label .sf-tooltip {
	margin-left: 5px;
}

.merchant-form .form-row .form-col:first-child:last-child .sf-checkbox {
	margin-bottom: 16px;
}

.merchant-form hr {
	display: none;

	@include media('>=tablet') {
		border-left: 0;
		border-right: 0;
		border-top: 0;
		display: block;
		height: 1px;
		margin-bottom: 32px;
		margin-left: 60px;
		margin-right: 60px;
	}

	@include media('>=desktop') {
		margin-left: 84px;
		margin-right: 84px;
	}

	@include media('>=desktop-lg') {
		margin-left: 96px;
		margin-right: 96px;
	}
}

.merchant-form ::v-deep .form-row .form-col .sf-datepicker__input-wrapper .sf-datepicker__calendar.focus-visible {
	outline: 2px solid #6fb4d8;
	outline-offset: 3px;
}
</style>
